import { render, staticRenderFns } from "./step5_5.vue?vue&type=template&id=938898ec"
import script from "./step5_5.vue?vue&type=script&lang=js"
export * from "./step5_5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports